var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "discussion discussion-facebook discussion-linkedin" },
    [
      _c(
        "div",
        { staticClass: "detail-event-header" },
        [
          _c("AvatarComponent", {
            attrs: {
              typeNetwork: _vm.page.network,
              urlPicture:
                _vm.infoUser.user && _vm.infoUser.user.logoV2
                  ? _vm.infoUser.user.logoV2
                  : null,
            },
          }),
          _c("div", { staticClass: "info" }, [
            _c("div", { staticClass: "namePage" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.infoUser.name) +
                  "\n              "
              ),
            ]),
            _vm._m(0),
          ]),
          _c(
            "div",
            { staticClass: "selectActionEvent" },
            [
              _c("SelectComponent", {
                attrs: {
                  changeValueSelect: _vm.changeStatus,
                  data: {
                    treated: _vm.$t("dash.inbox.state.treated"),
                    waiting: _vm.$t("dash.inbox.state.waiting"),
                  },
                  valueSelect: [1, 3].includes(_vm.event.status)
                    ? "treated"
                    : "waiting",
                  positionY: "bottom",
                  positionAuto: false,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.isLoading &&
      Object.keys(_vm.infoConversation).length &&
      Object.keys(_vm.infoUser).length &&
      _vm.messages &&
      _vm.messages.data
        ? _c(
            "ul",
            {
              ref: "discussionScrool",
              staticClass: "discussion-order scrollable",
            },
            _vm._l(
              _vm.messages.data.messengerMessagesBySyncToken.elements,
              function (discut, key) {
                return _c("li", { key: key }, [
                  !_vm.messages.data[key + 1] ||
                  new Date(discut.deliveredAt).getTime() -
                    new Date(_vm.messages.data[key + 1].deliveredAt).getTime() >
                    900000
                    ? _c("div", { staticClass: "date" }, [
                        _vm._v(_vm._s(_vm.dateFormat(discut.deliveredAt))),
                      ])
                    : _vm._e(),
                  !discut.sender.backendUrn.includes("urn:li:pageMailbox:")
                    ? _c("div", { staticClass: "message-received" }, [
                        _c("div", { staticClass: "message-received-content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "message-received-content-text text",
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(discut.body ? discut.body.text : "")
                                ),
                              ]),
                              discut.renderContent &&
                              discut.renderContent.length
                                ? _c(
                                    "Tooltip",
                                    {
                                      attrs: {
                                        text: _vm.$t(
                                          "dash.inbox.content.show-media.description.linkedin"
                                        ),
                                        position: "top",
                                      },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "show-media",
                                          attrs: {
                                            href: _vm.event.data.conversationUrl.replace(
                                              "/messaging/",
                                              `/company/${_vm.page.network_id}/admin/inbox/`
                                            ),
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.inbox.content.show-media.title.linkedin"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              discut.reactionSummaries &&
                              discut.reactionSummaries.length
                                ? _c(
                                    "div",
                                    { staticClass: "containerReactions" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "reactions" },
                                        _vm._l(
                                          discut.reactionSummaries,
                                          function (reaction, keyReaction) {
                                            return _c(
                                              "i",
                                              { key: keyReaction },
                                              [_vm._v(_vm._s(reaction.emoji))]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "container-actions-message" }),
                      ])
                    : _c("div", { staticClass: "message-sent" }, [
                        _c("div", { staticClass: "message-sent-content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "message-sent-content-text",
                              class: {
                                text:
                                  discut.body &&
                                  discut.body.text &&
                                  discut.body.text.length,
                              },
                            },
                            [
                              discut.body &&
                              discut.body.text &&
                              discut.body.text.length
                                ? _c("p", [_vm._v(_vm._s(discut.body.text))])
                                : _vm._e(),
                              discut.renderContent &&
                              discut.renderContent.length
                                ? _c(
                                    "Tooltip",
                                    {
                                      attrs: {
                                        text: _vm.$t(
                                          "dash.inbox.content.show-media.description.linkedin"
                                        ),
                                        position: "top",
                                      },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "show-media",
                                          attrs: {
                                            href: _vm.event.data.conversationUrl.replace(
                                              "/messaging/",
                                              `/company/${_vm.page.network_id}/admin/inbox/`
                                            ),
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.inbox.content.show-media.title.linkedin"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              discut.reactionSummaries &&
                              discut.reactionSummaries.length
                                ? _c(
                                    "div",
                                    { staticClass: "containerReactions" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "reactions" },
                                        _vm._l(
                                          discut.reactionSummaries,
                                          function (reaction, keyReaction) {
                                            return _c(
                                              "i",
                                              { key: keyReaction },
                                              [_vm._v(_vm._s(reaction.emoji))]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]),
                ])
              }
            ),
            0
          )
        : _c(
            "ul",
            { staticClass: "discussion-order scrollable" },
            _vm._l(8, function (index) {
              return _c("li", { key: index }, [
                Math.random() > 0.5
                  ? _c(
                      "div",
                      { staticClass: "message-received content-loading" },
                      [
                        _c("div", { staticClass: "message-received-content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "message-received-content-text text",
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s("w".repeat(5 + Math.random() * 100))
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "container-actions-message" }),
                      ]
                    )
                  : _c("div", { staticClass: "message-sent content-loading" }, [
                      _c("div", { staticClass: "message-sent-content" }, [
                        _c(
                          "div",
                          { staticClass: "message-sent-content-text text" },
                          [
                            _c("p", [
                              _vm._v(
                                _vm._s("w".repeat(5 + Math.random() * 100))
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "container-actions-message" }),
                    ]),
              ])
            }),
            0
          ),
      _c("FormSendMessage", {
        attrs: { acceptTypeMedia: "image/*" },
        on: { onSubmitMessage: _vm.onSubmitMessage },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "typeEvent" }, [
      _c("p", [_vm._v("Discussion privée")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }